import { add } from 'date-fns';
import { produce } from 'immer';
import Cookie from 'js-cookie';
import { z } from 'zod';
import { COOKIE_NAME } from '../hooks/useClientSidePresignupExperiment';

export const cookieSchema = z
  .object({
    enrollments: z.array(
      z.object({
        experimentId: z.number(),
        variant: z.number(),
      })
    ),
  })
  .catch({
    enrollments: [],
  });

export type ExperimentEnrollments = z.infer<typeof cookieSchema>;

const getPersistedEnrollments = () => {
  const value = Cookie.get(COOKIE_NAME);
  const blank: ExperimentEnrollments = {
    enrollments: [],
  };
  if (value === undefined) {
    return blank;
  }

  try {
    const json = JSON.parse(value);
    return cookieSchema.parse(json);
  } catch {
    return blank;
  }
};

export function persistedEnrollment(experimentId: number, variant: number) {
  const cookieVariants = getPersistedEnrollments();
  const next = produce(cookieVariants, (draft) => {
    let found: boolean = false;
    draft.enrollments = draft.enrollments.map((d) => {
      if (d.experimentId === experimentId) {
        found = true;
        return {
          experimentId,
          variant,
        };
      }

      return d;
    });

    // couldn't find a match, push it!
    if (found === false) {
      draft.enrollments.push({ experimentId, variant });
    }
  });

  Cookie.set(COOKIE_NAME, JSON.stringify(next), {
    domain: '.hungryroot.com',
    expires: add(new Date(), {
      years: 1,
    }),
  });
}

export function getPersistedEnrollment(expId: number) {
  const { enrollments } = getPersistedEnrollments();
  return enrollments.find(
    ({ experimentId }) => Math.floor(experimentId / 100) === expId
  );
}
